import React from 'react'
import styled from '@emotion/styled'
import { Flex } from '@mindfulchefuk/design-system'
import { TrustpilotMicroCombo } from '@mindfulchefuk/features/Onboarding/components/TrustpilotMicroCombo/TrustpilotMicroCombo'

const Wrapper = styled(Flex)`
  @media screen and (max-width: 640px) {
    display: none;
  }
`

export const RecipeModalTrustpilotFooter = () => {
  return (
    <Wrapper
      alignItems="center"
      bg="#f9f9ff"
      data-testid="trustpilot"
      height="47px"
      justifyContent="center"
    >
      <TrustpilotMicroCombo variant="star" />
    </Wrapper>
  )
}
